export default {
  submitText: '保存',
  emptyBtn: false,
  column: [
    {
      label: '上级结构',
      prop: 'parentObjectName',
      disabled: true,
      span: 12,
    },
    {
      label: '序号',
      prop: 'indexNum',
      rules: [
        {
          required: true,
          message: '请输入序号'
        },
        { pattern:/^[1-9]\d{0,2}$/, message: '请输入不超过3位的正整数' }
      ],
      span: 12,
    },
    {
      label: '名称',
      prop: 'objectName',
      rules: [
        {
          required: true,
          message: '请输入名称',
        },
        { min: 1, max: 30, message: '长度在 1 到 30 个字符' }
      ],
      span: 12,
    }
  ],
};
